<template>
  <svg
    class="vdb-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :aria-hidden="label ? undefined : 'true'"
    :aria-label="label || undefined"
    role="img"
  >
    <template v-if="name === 'type'">
      <path d="M5 5h14M12 5v14M8.5 19h7" />
    </template>
    <template v-else-if="name === 'message-circle'">
      <path d="M20.25 11.25c0 4.14-3.69 7.5-8.25 7.5a9.2 9.2 0 0 1-3.6-.72L4 19.5l1.47-3.68a7.08 7.08 0 0 1-1.72-4.57c0-4.14 3.69-7.5 8.25-7.5s8.25 3.36 8.25 7.5Z" />
    </template>
    <template v-else-if="name === 'eye'">
      <path d="M2.25 12s3.75-6.75 9.75-6.75S21.75 12 21.75 12 18 18.75 12 18.75 2.25 12 2.25 12Z" />
      <circle cx="12" cy="12" r="2.75" />
    </template>
    <template v-else-if="name === 'hook'">
      <circle cx="13" cy="4" r="2" />
      <path d="M13 6v8.75a5.25 5.25 0 0 1-10.5 0V13" />
      <path d="m2.5 13 3 3" />
    </template>
  </svg>
</template>

<script>
const ICON_NAMES = ['type', 'message-circle', 'eye', 'hook'];

export default {
  name: 'VdbIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator: value => ICON_NAMES.includes(value),
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    strokeWidth: {
      type: [Number, String],
      default: 1.8,
    },
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.vdb-icon {
  display: block;
  flex: 0 0 auto;
}
</style>
